import Chart from "react-apexcharts";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { Stack } from "@bookingcom/bui-react";
import { ChartHeader } from "../ChartHeader";
import { ChartYaxisTitle } from "../ChartYaxisTitle";
import { useAverageDiscountChartController } from "./AverageDiscountChart.controller";
import type { Metric } from "../../../types";
import { CHART_HEIGHT } from "../ChartConstants";
import "../Charts.css";

export type AverageDiscountAirlineSeries = {
  airlineCode: string;
  airlineName: string;
  euroMetric: Metric;
  percentageMetric: Metric;
};

export type AverageDiscountChartProps = {
  series: AverageDiscountAirlineSeries[];
  multiAirline?: boolean;
};

export const AverageDiscountChart = ({ series, multiAirline = false }: AverageDiscountChartProps) => {
  const i18n = useI18n();
  const {
    averageDiscountEuro,
    averageDiscountPercentage,
    options,
    series: chartSeries,
  } = useAverageDiscountChartController({ series, multiAirline });
  const numOfAirlines = chartSeries.length;

  return (
    <Stack gap={multiAirline ? 4 : 0}>
      <ChartHeader
        titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_name"))}
        titleTooltipText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_tooltip"))}
        subtitleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_subheader"))}
        subtitleValue={`€${averageDiscountEuro}`}
        subtitleExtra={
          multiAirline
            ? i18n.trans(
                t("flights_airline_portal_group_view_avg_discount_subhead_result", {
                  variables: {
                    percent: averageDiscountPercentage,
                    num_airlines: numOfAirlines,
                    num_exception: numOfAirlines,
                  },
                })
              )
            : i18n.trans(
                t("flights_airline_portal_realtime_performance_metric_two_subheader_percentage", {
                  variables: {
                    percent: averageDiscountPercentage,
                  },
                })
              )
        }
      />
      <Stack mixin={{ position: "relative" }}>
        {multiAirline ? (
          <ChartYaxisTitle
            titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_yaxis_b"))}
          />
        ) : (
          <>
            <ChartYaxisTitle
              titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_yaxis_a"))}
            />
            <ChartYaxisTitle
              titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_two_yaxis_b"))}
              opposite={true}
            />
          </>
        )}
        <Chart options={options} series={chartSeries} type="line" height={CHART_HEIGHT} />
      </Stack>
    </Stack>
  );
};
